import React                    from 'react';
import PropTypes                from 'prop-types';
import moment                   from 'moment';
import { useTranslation }       from 'react-i18next';
import useStyles                from './styles';
import { isTrajectory }         from '../utils';

import GridItem                 from '~/components/GridItem';
import GridContainer            from '~/components/GridContainer';
import Paper                    from '~/components/Paper';
import Timeline                 from '@material-ui/icons/Timeline';
import Divider                  from '@material-ui/core/Divider';
import Typography               from '@material-ui/core/Typography';
import EventRecord              from '~/records/EventRecord';

function PaperTop({record, loading}){
  const { t } = useTranslation();
  const classes = useStyles();

  const trExtra = (extra) => t(`event.extras.${extra}`);

  return(
    <Paper
      Icon={Timeline}
      iconColor='blue'
      title={loading ? t('loading') : moment(record.get('start_date')).format('DD.MM.YY - HH:mm')}
      loading={loading}
    >
      <Divider/>
      {isTrajectory(record.get('event_type')) && <>
      <GridContainer className={classes.grid}>
        <GridItem md={2} xs={4}>
          <Typography color='textSecondary'>{trExtra('start_time')}</Typography>
        </GridItem>
        <GridItem md={4} xs={8}>
          <Typography color='textSecondary'>{trExtra('start_location')}</Typography>
        </GridItem>
        <GridItem md={2} xs={4}>
          <Typography color='textSecondary'>{trExtra('end_time')}</Typography>
        </GridItem>
        <GridItem md={4} xs={8}>
          <Typography color='textSecondary'>{trExtra('end_location')}</Typography>
        </GridItem>
      </GridContainer>
      </>}
      {!isTrajectory(record.get('event_type')) && <>
      <GridContainer className={classes.grid}>
        <GridItem md={4} xs={4}>
          <Typography color='textSecondary'>{trExtra('time')}</Typography>
        </GridItem>
        <GridItem md={8} xs={8}>
          <Typography color='textSecondary'>{t('event.attributes.address')}</Typography>
        </GridItem>
      </GridContainer>
      </>}
      <Divider/>
      <GridContainer className={classes.grid}>
        {isTrajectory(record.get('event_type')) && <>
          <GridItem md={2} xs={4}>
            <Typography>{moment(record.get('start_date')).format('HH:mm')}</Typography>
          </GridItem>
          <GridItem md={4} xs={8}>
            <Typography>{record.get('address')}</Typography>
          </GridItem>
          <GridItem md={2} xs={4}>
            <Typography>{moment(record.get('end_date')).format('HH:mm')}</Typography>
          </GridItem>
          <GridItem md={4} xs={8}>
            <Typography>{record.get('address_end')}</Typography>
          </GridItem>
          </>}
          {!isTrajectory(record.get('event_type')) && <>
          <GridItem md={4} xs={4}>
            <Typography>{moment(record.get('start_date')).format('HH:mm')}</Typography>
          </GridItem>
          <GridItem md={8} xs={12}>
            <Typography>{record.get('address')}</Typography>
          </GridItem>
          </>}
      </GridContainer>
      <Divider/>
      </Paper>
  );
}

PaperTop.propTypes={
  loading: PropTypes.bool,
  record: PropTypes.instanceOf(EventRecord),
};

export default PaperTop;
